<template>
    <div class="index-container">
        <section class="section">
            <h1 class="is-flex" style="justify-content: space-between; margin-bottom: 20px;">
                <span class="title is-uppercase" v-if="componentTitle"> {{ componentTitle }} </span>
            </h1>

        </section>
    </div>
</template>

<script>
    export default {
        props: {
            buttons: {
                type: [Array, Object]
            },
            componentTitle: String,
            buttonAction: String,
            buttonLabel: String,
            buttonIcon: String,
            buttonType: String,
            buttonVisibility: String,
            messageTitle: String,
            messageType: String,
            messageText: String,
            showMessage: Boolean
        },
        methods: {
            canShowButton(visibility) {
                return visibility !== "false";
            },
            isMultipleButton() {
                return !!this.buttons.length;
            }
        },
        computed: {
            buttonActionComputed() {
                return this.buttonAction;
            },
            buttonLabelComputed() {
                return this.buttonLabel;
            }
        }
    }
</script>
